/* unplugin-vue-components disabled */import { render } from "./logistic-supplier.vue?vue&type=template&id=4ec0d258"
import script from "./logistic-supplier.vue?vue&type=script&lang=js"
export * from "./logistic-supplier.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/amoeba-logistics-information-system-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__